import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "merchant"
};
const _hoisted_2 = {
  class: "head"
};
const _hoisted_3 = {
  class: "nav"
};
const _hoisted_4 = ["onClick"];
import { ref } from 'vue';
import Home from "./components/home.vue";
import Process from './components/process.vue';
import Certification from './components/certification.vue';
import Problem from './components/problem.vue';
export default {
  __name: 'index',
  setup(__props) {
    const nav = ref(1);
    const navList = ref([{
      id: 1,
      name: "招商首页"
    }, {
      id: 2,
      name: "入驻流程"
    }, {
      id: 3,
      name: "资质要求"
    }
    // {
    //   id: 4,
    //   name: "常见问题"
    // },
    ]);

    //nav切换
    const changeNav = id => {
      nav.value = id;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          onClick: $event => changeNav(item.id),
          key: index,
          class: _normalizeClass(nav.value == item.id ? 'list checked' : 'list')
        }, _toDisplayString(item.name), 11, _hoisted_4);
      }), 128))])]), nav.value == 1 ? (_openBlock(), _createBlock(Home, {
        key: 0,
        onToPage: changeNav
      })) : _createCommentVNode("", true), nav.value == 2 ? (_openBlock(), _createBlock(Process, {
        key: 1
      })) : _createCommentVNode("", true), nav.value == 3 ? (_openBlock(), _createBlock(Certification, {
        key: 2
      })) : _createCommentVNode("", true), nav.value == 4 ? (_openBlock(), _createBlock(Problem, {
        key: 3
      })) : _createCommentVNode("", true)]);
    };
  }
};